import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <div className="footer">
            <p>Data provided by Marvel. © 2014 Marvel</p>
        </div>
    );
};

export default Footer;
